import { contactContent } from '@/mocks/homepage';

export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-black text-foreground-900 mb-2">{contactContent.title}</h2>
        <p className="text-sm md:text-base text-foreground-600 mb-6 md:mb-8">{contactContent.subtitle}</p>

        <div className="space-y-3 md:space-y-4">
          <div className="flex items-center gap-3 p-4 bg-background-50 rounded-xl">
            <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg">
              <i className="ri-mail-line text-primary-500 text-lg"></i>
            </div>
            <div className="text-left">
              <div className="text-xs text-foreground-500">电子邮箱</div>
              <div className="text-sm md:text-base font-medium text-foreground-900">{contactContent.email}</div>
            </div>
          </div>
          <div className="flex items-center gap-3 p-4 bg-background-50 rounded-xl">
            <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg">
              <i className="ri-wechat-line text-accent-500 text-lg"></i>
            </div>
            <div className="text-left">
              <div className="text-xs text-foreground-500">微信</div>
              <div className="text-sm md:text-base font-medium text-foreground-900">{contactContent.wechat}</div>
            </div>
          </div>
        </div>

        <p className="mt-5 md:mt-6 text-sm text-foreground-600">{contactContent.description}</p>
      </div>
    </section>
  );
}